<template>
  <div class="overlay"></div>
  <div class="elevated dialog">
    <slot></slot>
  </div>
</template>
